import React, { Component } from 'react';
import Autosuggest, { ItemAdapter } from '../../modules/autosuggest/Autosuggest.js';
import Config from '../../config';

class AutoAdapter extends ItemAdapter {
 renderItem(item) {
  return (
   <div className="repo">
    <div>
     <div className="repo-title">{item.name}</div>
    </div>
   </div>
  )
 }
}

AutoAdapter.instance = new AutoAdapter();

class AutosuggestInput extends Component {
 constructor(props) {
  super(props);

  this.doChange = this.doChange.bind(this);
  this.doSearch = this.doSearch.bind(this);
  this.doSelect = this.doSelect.bind(this);
  this.onClose = this.onClose.bind(this);

  this.state = {
   searchValue: '',
   searchMessage: '',
   searchSelected: null,
   searchResults: []
  }
 }

 doSearch(search) {
  if(search == '' || this.state.searchValue != search) {
  const sp = search.lastIndexOf('/');
  if (sp >= 0) search = search.substring(sp + 1);
  this.setState({ searchMessage: 'Realizando busqueda...' });
  this.props.reqAPI(Config.apiURI + '/api/establishments', 'POST', {
   page: 1,
   sizePerPage: 6,
   filters: {
    name: {
     filterVal: search,
     filterType: 'TEXT',
     comparator: 'LIKE',
     caseSensitive: false
    }
   }
  }).then(data => {
   if (data.total > 0) {
    this.setState({ searchResults: data.items, searchMessage: '', searchSelected: null });
   } else {
    this.setState({ searchResults: null, searchMessage: 'No se han encontrado establecimientos', searchSelected: null });
   }
  });
 }
 }


 doChange(value) {
  this.props.handleCallback(false);
  this.setState({ searchValue: value, searchSelected: null }, () => {
   this.doSearch(value);
  })
 }

 doSelect(establishment) {
  if (establishment !== null && establishment.ID !== undefined) {
   this.props.handleCallback(establishment);
   this.setState({ searchSelected: establishment, searchValue: establishment.name, searchResults: [establishment], searchMessage: '' });
  }
 }

 onClose(event) {
  if(!this.state.searchSelected) {
   this.setState({ searchValue: '' });
  }
 }

 componentDidMount() {
  this.doSearch('');
 }

 componentWillReceiveProps(nextProps) {
  if(nextProps.value != '') this.setState({ searchValue: nextProps.value });
}

 render() {
  return (
   <Autosuggest
    className={this.props.className}
    value={this.state.searchValue}
    showToggle={true}
    searchDebounce={500}
    allowDuplicates={false}
    closeOnCompletion={true}
    datalist={this.state.searchResults}
    datalistOnly={false}
    datalistPartial={false}
    datalistMessage={this.state.searchMessage}
    itemReactKeyPropName="ID"
    itemValuePropName="name"
    placeholder={this.props.placeholder ? this.props.placeholder : "Asigna un establecimiento a este producto"}
    onSearch={this.doSearch}
    onChange={this.doChange}
    onSelect={this.doSelect}
    onBlur={this.onClose}
    itemAdapter={AutoAdapter.instance} />
  )
 }
}

export default AutosuggestInput;



// WEBPACK FOOTER //
// ./websources/views/Products/Autosuggest.js